import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

export const MAIN_TIME_ZONES = [
  {
    zone: 'America/New_York',
    label: 'Eastern Time',
  },
  {
    zone: 'America/Chicago',
    label: 'Central Time',
  },
  {
    zone: 'America/Denver',
    label: 'Mountain Time',
  },
  {
    zone: 'America/Los_Angeles',
    label: 'Pacific Time',
  },
];

export const ALL_TIME_ZONES = [
  { zone: 'Atlantic/Azores', label: 'Azores' },
  { zone: 'Atlantic/Cape_Verde', label: 'Cape Verde Islands' },
  { zone: 'Atlantic/South_Georgia', label: 'Mid-Atlantic' },
  { zone: 'America/Sao_Paulo', label: 'Brasilia' },
  { zone: 'America/Argentina/Buenos_Aires', label: 'Buenos Aires, Georgetown' },
  { zone: 'America/Godthab', label: 'Greenland' },
  { zone: 'America/St_Johns', label: 'Newfoundland and Labrador' },
  { zone: 'America/Halifax', label: 'Atlantic Time (Canada)' },
  { zone: 'America/La_Paz', label: 'Caracas, La Paz' },
  { zone: 'America/Cuiaba', label: 'Manaus' },
  { zone: 'America/Santiago', label: 'Santiago' },
  { zone: 'America/Bogota', label: 'Bogota, Lima, Quito' },
  { zone: 'America/New_York', label: 'Eastern Time' },
  { zone: 'America/Indiana/Indianapolis', label: 'Indiana (East)' },
  { zone: 'America/Costa_Rica', label: 'Central America' },
  { zone: 'America/Chicago', label: 'Central Time' },
  { zone: 'America/Monterrey', label: 'Guadalajara, Mexico City, Monterrey' },
  { zone: 'America/Edmonton', label: 'Saskatchewan' },
  { zone: 'America/Phoenix', label: 'Arizona' },
  { zone: 'America/Chihuahua', label: 'Chihuahua, La Paz, Mazatlan' },
  { zone: 'America/Denver', label: 'Mountain Time' },
  { zone: 'America/Los_Angeles', label: 'Pacific Time' },
  { zone: 'America/Anchorage', label: 'Alaska' },
  { zone: 'Pacific/Honolulu', label: 'Hawaii' },
  { zone: 'Pacific/Apia', label: 'Midway Island, Samoa' },
  { zone: 'Africa/Monrovia', label: 'Casablanca, Monrovia' },
  {
    zone: 'Europe/London',
    label: 'Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London',
  },
  {
    zone: 'Europe/Berlin',
    label: 'Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
  },
  {
    zone: 'Europe/Belgrade',
    label: 'Belgrade, Bratislava, Budapest, Ljubljana, Prague',
  },
  { zone: 'Europe/Paris', label: 'Brussels, Copenhagen, Madrid, Paris' },
  { zone: 'Europe/Belgrade', label: 'Sarajevo, Skopje, Warsaw, Zagreb' },
  { zone: 'Africa/Lagos', label: 'West Central Africa' },
  { zone: 'Europe/Istanbul', label: 'Athens, Bucharest, Istanbul' },
  { zone: 'Africa/Cairo', label: 'Cairo' },
  { zone: 'Africa/Harare', label: 'Harare, Pretoria' },
  {
    zone: 'Europe/Riga',
    label: 'Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius',
  },
  { zone: 'Asia/Jerusalem', label: 'Jerusalem' },
  { zone: 'Europe/Minsk', label: 'Minsk' },
  { zone: 'Africa/Windhoek', label: 'Windhoek' },
  { zone: 'Asia/Baghdad', label: 'Baghdad' },
  { zone: 'Asia/Kuwait', label: 'Kuwait, Riyadh' },
  { zone: 'Europe/Moscow', label: 'Moscow, St. Petersburg, Volgograd' },
  { zone: 'Africa/Nairobi', label: 'Nairobi' },
  { zone: 'Asia/Tehran', label: 'Tehran' },
  { zone: 'Asia/Muscat', label: 'Abu Dhabi, Muscat' },
  { zone: 'Asia/Baku', label: 'Baku' },
  { zone: 'Asia/Tbilisi', label: 'Tblisi' },
  { zone: 'Asia/Yerevan', label: 'Yerevan' },
  { zone: 'Asia/Kabul', label: 'Kabul' },
  { zone: 'Asia/Yekaterinburg', label: 'Ekaterinburg' },
  { zone: 'Asia/Tashkent', label: 'Islamabad, Karachi, Tashkent' },
  { zone: 'Asia/Calcutta', label: 'Chennai, Kolkata, Mumbai, New Delhi' },
  { zone: 'Asia/Kathmandu', label: 'Kathmandu' },
  { zone: 'Asia/Novosibirsk', label: 'Almaty, Novosibirsk' },
  { zone: 'Asia/Almaty', label: 'Astana, Dhaka' },
  { zone: 'Asia/Colombo', label: 'Sri Jayawardenepura' },
  { zone: 'Asia/Rangoon', label: 'Yangon (Rangoon)' },
  { zone: 'Asia/Bangkok', label: 'Bangkok, Hanoi, Jakarta' },
  { zone: 'Asia/Krasnoyarsk', label: 'Krasnoyarsk' },
  { zone: 'Asia/Shanghai', label: 'Beijing, Chongqing, Hong Kong SAR, Urumqi' },
  { zone: 'Asia/Irkutsk', label: 'Irkutsk, Ulaanbaatar' },
  { zone: 'Asia/Singapore', label: 'Kuala Lumpur, Singapore' },
  { zone: 'Australia/Perth', label: 'Perth' },
  { zone: 'Asia/Taipei', label: 'Taipei' },
  { zone: 'Asia/Tokyo', label: 'Osaka, Sapporo, Tokyo' },
  { zone: 'Asia/Seoul', label: 'Seoul' },
  { zone: 'Asia/Yakutsk', label: 'Yakutsk' },
  { zone: 'Australia/Adelaide', label: 'Adelaide' },
  { zone: 'Australia/Darwin', label: 'Darwin' },
  { zone: 'Australia/Brisbane', label: 'Brisbane' },
  { zone: 'Australia/Sydney', label: 'Canberra, Melbourne, Sydney' },
  { zone: 'Pacific/Guam', label: 'Guam, Port Moresby' },
  { zone: 'Australia/Hobart', label: 'Hobart' },
  { zone: 'Asia/Vladivostok', label: 'Vladivostok' },
  {
    zone: 'Pacific/Guadalcanal',
    label: 'Magadan, Solomon Islands, New Caledonia',
  },
  { zone: 'Pacific/Auckland', label: 'Auckland, Wellington' },
  { zone: 'Pacific/Fiji', label: 'Fiji Islands, Kamchatka, Marshall Islands' },
  { zone: 'Pacific/Tongatapu', label: "Nuku'alofa" },
];

export const toTimezone = (date: Date, timeZone: string): Date => {
  const dateWithoutZone = dayjs
    .tz(date, timeZone)
    .format('YYYY-MM-DDTHH:mm:ss.SSS');
  const localZone = dayjs(dateWithoutZone).format('Z');
  const dateWithLocalZone = [dateWithoutZone, localZone].join('');

  return new Date(dateWithLocalZone);
};

export const fromTimezone = (date: Date, timeZone: string): Date => {
  const dateWithoutZone = dayjs(date).format('YYYY-MM-DDTHH:mm:ss.SSS');
  const otherZone = dayjs.tz(date, timeZone).format('Z');
  const dateWithOtherZone = [dateWithoutZone, otherZone].join('');

  return new Date(dateWithOtherZone);
};

export enum EVideoStreamType {
  PRE_RECORDED_VIDEO = 'PRE_RECORDED_VIDEO',
  EXTERNAL = 'EXTERNAL',
  AGORA_VIDEO_CALL='AGORA_VIDEO_CALL'
}

export enum EEventType {
  SIMPLE = 'SimpleEventV2',
  CONFERENCE = 'ConferenceEventV2',
}
